export const delimiterLabels = [
  { delimiter: '-', description: 'Use "-". Your generated deploy URL will be "*-ze.your.domain"' },
  { delimiter: '.', description: 'Use ".". Your generated deploy URL will be "*.ze.your.domain"' },
];
